var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "suppleMaterial global-page-base-layout" },
    [
      _c("div", { staticClass: "select-conditions" }, [
        _c(
          "div",
          { staticClass: "select-conditions-row" },
          [
            _c("el-col", { attrs: { span: 12 } }, [
              _c(
                "div",
                { staticClass: "grid-content bg-purple" },
                [
                  _vm._v("\n          受理号：\n          "),
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    model: {
                      value: _vm.num,
                      callback: function ($$v) {
                        _vm.num = $$v
                      },
                      expression: "num",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 12 } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "select-conditions-row",
            staticStyle: { "text-indent": "5em" },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "medium" },
                on: { click: _vm.screen },
              },
              [_vm._v("筛选")]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "clear-all", on: { click: _vm.clearAllConditon } },
              [_vm._v("清空筛选条件")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "suppleMaterial-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                height: "calc(100vh - 270px)",
                "header-cell-style": { background: _vm.tableHeaderColor },
                "cell-style": { padding: "4px 0" },
                "row-style": { height: "32px" },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { label: "案号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.caseNo
                          ? _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.caseNo))]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v("暂无案号")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { width: "150", prop: "caseId", label: "受理号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "registerApplyTime", label: "申请日期" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appName", label: "申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "resName", label: "被申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "uploadTime", label: "提交时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.handleClick(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "material-dialog",
          attrs: { title: "材料文件", visible: _vm.fileVisble, width: "800px" },
          on: {
            "update:visible": function ($event) {
              _vm.fileVisble = $event
            },
          },
        },
        [
          _c("div", { staticClass: "case-info-header" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("案号：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.currentCaseInfo.caseNo || "暂无案号")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("受理号：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.currentCaseInfo.caseId || "")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("申请人：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.currentCaseInfo.appName || "")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("span", { staticClass: "info-label" }, [_vm._v("被申请人：")]),
              _vm._v(" "),
              _c("span", { staticClass: "info-value" }, [
                _vm._v(_vm._s(_vm.currentCaseInfo.resName || "")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "material-table-wrapper" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.fileLoading,
                      expression: "fileLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.MaterialData,
                    "header-cell-style": { background: _vm.tableHeaderColor },
                    "cell-style": { padding: "8px 0" },
                    "row-style": { height: "40px" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "fileName", label: "名称" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: {
                                  type: "primary",
                                  underline: false,
                                  href: scope.row.aliyunOssHref,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.fileName) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "提交时间" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.ctime) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.fileVisble = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }